export default __webpack_public_path__ + "static/media/locker.25066a1a.svg";